import { useEffect, useRef } from 'react'

const useOutsideClick = (ref, callback) => {
    const startTarget = useRef(null)

    useEffect(() => {
        const handleMouseDown = (event) => {
            startTarget.current = event.target
        }

        const handleMouseUp = (event) => {
            if (!ref.current || ref.current.contains(startTarget.current) || ref.current.contains(event.target)) {
                return
            }

            callback(event)
        }

        document.addEventListener('mousedown', handleMouseDown)
        document.addEventListener('mouseup', handleMouseUp)

        return () => {
            document.removeEventListener('mousedown', handleMouseDown)
            document.removeEventListener('mouseup', handleMouseUp)
        }
    }, [ref, callback])

    return () => {}
}

export default useOutsideClick


// if (event.type === 'mousemove' || event.type === 'touchmove') {
//     setIsDragging(true)
//   }

//   if (event.type === 'mouseup' || event.type === 'touchend') {
//     setTimeout(() => {
//       setIsDragging(false);
//     }, 100);

//   }
